import React from 'react';
import dayjs from 'dayjs';
import { StateInfo } from '../types';
import { Popover, Space } from 'antd';
import {
  CheckOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
  ScheduleOutlined,
  SettingOutlined,
  StopOutlined,
  SyncOutlined,
  VideoCameraOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import Paragraph from 'antd/es/typography/Paragraph';

type BroadcastStateIconProps = {
  stateInfo?: StateInfo;
  broadcastTimeframe: { estStartTime: string; estEndTime: string };
  displayHelp: boolean;
  size: 'small' | 'large';
};

const BroadcastStateIcon: React.FC<BroadcastStateIconProps> = ({
  stateInfo,
  broadcastTimeframe,
  displayHelp,
  size,
}) => {
  const getStateIcon = (displayHelp: boolean, stateInfo?: StateInfo) => {
    const iconFontSize: '24px' | '48px' = size === 'large' ? '48px' : '24px';
    return (
      <Space>
        {(() => {
          if (!stateInfo) {
            return <QuestionCircleOutlined style={{ fontSize: iconFontSize }} />;
          }
          switch (stateInfo.code) {
            case 'SCHEDULED':
              if (dayjs().isAfter(dayjs(broadcastTimeframe.estStartTime))) {
                // This can come up if the time has come clientside but the
                // newest information from the backend has not been fetched yet.
                return <SyncOutlined style={{ fontSize: iconFontSize }} spin />;
              }
              return <ScheduleOutlined style={{ fontSize: iconFontSize }} />;
            case 'ACTIVE':
              return <VideoCameraOutlined style={{ fontSize: iconFontSize, color: 'green' }} />;
            case 'STREAMING':
              return <SettingOutlined style={{ fontSize: iconFontSize, color: 'green' }} spin />;
            case 'OVERSTREAMING':
              return <SettingOutlined style={{ fontSize: iconFontSize, color: 'orange' }} spin />;
            case 'FINISHED':
              return <CheckOutlined style={{ fontSize: iconFontSize, color: 'green' }} />;
            case 'CANCELLED':
              return <StopOutlined style={{ fontSize: iconFontSize, color: 'red' }} />;
            case 'ERROR':
              return <WarningOutlined style={{ fontSize: iconFontSize, color: 'red' }} />;
            default:
              return <QuestionCircleOutlined style={{ fontSize: iconFontSize }} />;
          }
        })()}
        {stateInfo && displayHelp && (
          <Popover
            title={stateInfo.user_info_meaning}
            content={
              <Paragraph>
                <ul>
                  {stateInfo.user_info_details &&
                    stateInfo.user_info_details.length > 0 &&
                    stateInfo.user_info_details.map((detail: string, index: number) => <li key={index}>{detail}</li>)}
                </ul>
              </Paragraph>
            }
          >
            <InfoCircleOutlined style={{ fontSize: '20px', opacity: 0.25 }} />
          </Popover>
        )}
      </Space>
    );
  };
  return getStateIcon(displayHelp, stateInfo);
};

export default BroadcastStateIcon;
